<template>
  <div class="active">
    <i class="back" @click="back"></i>
    <img class="title" :src="titleImg" alt />
    <div class="content">
      <img :src="audioData.img" :class="{'play': isPlay}" alt />
      <div class="mask"></div>
      <div class="play-icon" :class="{'play': isPlay}" @click="togglePlay"></div>
      <div class="effect" :class="{'play': isPlay}"></div>
    </div>
    <div class="info">
      <h3>{{audioData.title}}</h3>
      <p v-if="duration">{{duration.minute}}分{{duration.seconds}}秒</p>
    </div>
    <div class="tips">家长盒子奖励特别版</div>
  </div>
</template>

<script>
import titleImg from "@/assets/images/booklistenworld/title_logo.png";
import coverImg from "@/assets/images/booklistenworld/cover_1.png";
import utils from "@/assets/js/utils";

const audioArr = [
  {
    title: "【演化启蒙课】雪球地球·八亿年前的开始",
    src: "https://appd.knowbox.cn/parent/activity/libao/01_xueqiu.mp3",
    img: "https://appd.knowbox.cn/parent/activity/libao/buketingshijie_1.png"
  },
  {
    title: "【化学启蒙课】这种气体脾气坏",
    src: "https://appd.knowbox.cn/parent/activity/libao/02_qiti.mp3",
    img: "https://appd.knowbox.cn/parent/activity/libao/buketingshijie_2.png"
  },
  {
    title: "【动物启蒙课】百兽之王",
    src: "https://appd.knowbox.cn/parent/activity/libao/03_wanshou.mp3",
    img: "https://appd.knowbox.cn/parent/activity/libao/buketingshijie_3.png"
  }
];

export default {
  name: "entry",
  data() {
    return {
      titleImg: "",
      coverImg: "",
      isPlay: false,
      isEnd: false,
      duration: "",
      audio: null,
      audioData: null
    };
  },
  methods: {
    back: function() {
      let url = "hybird://method/exit";
      location.href = url;
    },
    togglePlay: function() {
      let that = this;
      if (!that.isPlay) {
        that.audio.play();
        that.isPlay = true;
        utils.sendLog(
          {
            token: that.token,
            source: "h5",
            extensionJson: {
              courseid: that.courseId
            }
          },
          "jz0227"
        );
        let timer = setInterval(() => {
          if (that.audio.ended && !that.isEnd) {
            that.isEnd = true;
            that.isPlay = false;
            clearInterval(timer);
            utils.sendLog(
              {
                token: that.token,
                source: "h5",
                extensionJson: {
                  courseid: that.courseId
                }
              },
              "jz0228"
            );
          }
        }, 300);
      } else {
        that.audio.pause();
        that.isPlay = false;
      }
    },
    formatTime: function(t) {
      let minute = Math.floor(t / 60);
      let seconds = Math.floor(t % 60);
      function handle(num) {
        return num < 10 ? "0" + num : num;
      }
      return {
        minute: handle(minute),
        seconds: handle(seconds)
      };
    },
    init: async function() {
      let that = this;
      that.audio = new Audio(this.audioData.src);
      that.audio.load();
      that.audio.oncanplay = function() {
        that.duration = that.formatTime(that.audio.duration);
      };
    }
  },
  created: async function() {
    let that = this;
    that.courseId = utils.getQueryString("courseId");
    that.token = utils.getQueryString("token");
    that.audioData = audioArr[parseInt(that.courseId) - 1];

    utils.sendLog(
      {
        token: that.token,
        source: "h5",
        extensionJson: {
          courseid: that.courseId
        }
      },
      "jz0226"
    );
    this.init();
    this.titleImg = titleImg;
    this.coverImg = coverImg;
  }
};
</script>

<style lang="scss" scoped>
.active {
  background: url("../../assets/images/booklistenworld/bg.png") 0 0 / cover
    no-repeat;
  padding-top: 0.66rem;
  padding-bottom: 0.2rem;
  min-height: 100vh;
  .back {
    position: absolute;
    top: 0.31rem;
    left: 0.34rem;
    width: 0.6rem;
    height: 0.6rem;
    background: url("../../assets/images/booklistenworld/back.png") 0 0 / cover
      no-repeat;
  }
  /*iPhone X XS 2436x1125px at 458ppi */
  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    .back {
      top: calc(0.31rem+ constant(safe-area-inset-top));
      top: calc(0.31rem+ env(safe-area-inset-top));
    }
  }

  /*iPhone XR 1792x828px at 326ppi */
  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
    .back {
      top: calc(0.31rem+ constant(safe-area-inset-top));
      top: calc(0.31rem+ env(safe-area-inset-top));
    }
  }

  /* iPhone XS Max 2688x1242px at 458ppi */
  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
    .back {
      top: calc(0.31rem+ constant(safe-area-inset-top));
      top: calc(0.31rem+ env(safe-area-inset-top));
    }
  }
  .title {
    width: 3.92rem;
    height: 2rem;
    margin: 0 auto;
    display: block;
  }
  .content {
    width: 7rem;
    height: 4.6rem;
    margin: 1.56rem auto 0;
    position: relative;
    .mask {
      position: absolute;
      width: 4.6rem;
      height: 4.6rem;
      background: rgba(0, 0, 0, 0.24);
      right: 0;
      top: 0;
      left: 0;
      margin: 0 auto;
      border-radius: 50%;
    }
    img {
      width: 4.6rem;
      height: 4.6rem;
      border-radius: 50%;
      background: #000;
      display: block;
      margin: 0 auto;
    }
    img.play {
      animation: circleRoate 200s infinite;
      animation-timing-function: linear;
    }
    .play-icon {
      position: absolute;
      width: 1.1rem;
      height: 1.1rem;
      background: url("../../assets/images/booklistenworld/play_icon.png") 0 0 /
        cover no-repeat;
      right: 0;
      top: 50%;
      left: 0;
      margin: -0.55rem auto;
      z-index: 20;
    }
    .effect {
      position: absolute;
      width: 1.54rem;
      height: 4.1rem;
      background: url("../../assets/images/booklistenworld/effect_icon.png") 0 0 /
        cover no-repeat;
      right: 0;
      top: 0;
      transition: all 0.6s ease-in-out;
      transform-origin: top right;
      transform: rotate(0deg);
    }
    .play-icon.play {
      background: url("../../assets/images/booklistenworld/pause_icon.png") 0 0 /
        cover no-repeat;
      transform: rotate(0deg);
    }
    .effect.play {
      transform: rotate(20deg);
    }
  }
  .info {
    text-align: center;
    font-family: PingFangSC-Medium;
    margin-top: 0.8rem;
    h3 {
      font-size: 0.36rem;
      color: #fff;
    }
    p {
      font-size: 0.3rem;
      color: #b6c7d6;
      margin-top: 0.22rem;
    }
  }
  .tips {
    margin-top: 3.2rem;
    font-size: 0.24rem;
    color: #b6c7d6;
    text-align: center;
  }
}

/*iPhone X XS 2436x1125px at 458ppi */
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .active {
    padding-top: calc(0.66rem+ constant(safe-area-inset-top));
    padding-top: calc(0.66rem+ env(safe-area-inset-top));
  }
}

/*iPhone XR 1792x828px at 326ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
  .active {
    padding-top: calc(0.66rem+ constant(safe-area-inset-top));
    padding-top: calc(0.66rem+ env(safe-area-inset-top));
  }
}

/* iPhone XS Max 2688x1242px at 458ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
  .active {
    padding-top: calc(0.66rem+ constant(safe-area-inset-top));
    padding-top: calc(0.66rem+ env(safe-area-inset-top));
  }
}

@keyframes circleRoate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(7600deg);
  }
}
</style>